import { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import classNames from "classnames";
import { postCommonDelivery } from "../../../api/common";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000001;
  width: 100vw;
  height: 100vh;

  & strong {
    color: #e74c3c;
  }

  .modal-section {
    position: fixed;
    top: ${(props) => (props.onShipping ? "15vh" : "30vh")};
    left: 40vw;
    width: 30vw;
    height: ${(props) => (props.onShipping ? "70vh" : "40vh")};
    background-color: white;
    border-radius: 20px;
    overflow: auto;
    border: none;
    display: flex;
    flex-direction: column;

    @media only screen and (min-width: 1401px) and (max-width: 1600px) {
      left: 35vw;
      width: 30vw;
    }

    @media only screen and (min-width: 1200px) and (max-width: 1400px) {
      left: 30vw;
      width: 40vw;
    }

    @media only screen and (min-width: 992px) and (max-width: 1200px) {
      left: 30vw;
      width: 40vw;
    }

    @media only screen and (min-width: 768px) and (max-width: 991px) {
      left: 25vw;
      width: 50vw;
    }

    @media only screen and (min-width: 576px) and (max-width: 767px) {
      left: 17vw;
      width: 66vw;
    }

    @media only screen and (max-width: 575px) {
      left: 5vw;
      width: 90vw;
    }

    & > i {
      font-size: 2rem;
      color: black;
      cursor: pointer;
      :hover {
        color: #3bb77e;
      }
    }
  }

  .modal-header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #253d4e;

    @media only screen and (max-width: 575px) {
      font-size: 1rem;
    }

    & i {
      font-size: 14px;
      color: #253d4e;
      border: 2px solid #253d4e;
      border-radius: 50%;
      cursor: pointer;
      height: 25px;
      width: 25px;
      display: flex;
      justify-content: center;
      align-content: center;

      :hover {
        color: #3bb77e;
        border: 2px solid #3bb77e;
      }

      @media only screen and (max-width: 575px) {
        font-size: 12px;
      }
    }
  }

  .modal-content {
    width: 100%;
    /* height: calc(70vh - 63px); */
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border: none;
    margin: 0 auto;
    overflow-y: auto;
    & > span {
      color: black;
    }

    .status-top-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 2rem;

      h4 {
        @media only screen and (max-width: 575px) {
          font-size: 18px;
        }
      }

      .shipping-invoice {
        padding-top: 5px;
        font-size: 16px;
        font-weight: 500;
        color: #253d4e;
      }
    }

    .status-btm-wrapper {
      display: flex;
      flex-direction: column;

      .loading {
        margin-top: 100px !important;
      }
      .box-wrapper {
        padding-top: 10px;

        :first-child {
          padding-top: 1rem;
        }
      }

      .box-border {
        border: 1px solid #ececec;
        padding: 1rem;
      }

      .width-flex-full {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }

      .width-70 {
        width: 70%;
      }

      .box-header {
        color: #253d4e;
        font-weight: 500;
        word-break: keep-all;

        @media only screen and (max-width: 575px) {
          font-size: 14px;
          font-weight: 600;
        }
      }

      .box-sub-title {
        font-size: 14px;

        @media only screen and (max-width: 575px) {
          font-size: 12px;
          font-weight: 600;
        }
      }

      .width-30 {
        display: flex;
        justify-content: end;
        align-items: center;
      }

      .date-time {
        text-align: end;
        font-weight: 500;
        color: #3bb77e;
        word-break: keep-all;

        @media only screen and (max-width: 575px) {
          font-size: 12px;
          font-weight: 600;
        }
      }
    }
  }
`;

const OrderTrackingModal = ({
  orderData,
  onClickOrderTrackingModal,
  dummyList,
}) => {
  const [shippingList, setShipplingList] = useState([]);
  const [deliveryList, setDeliveryList] = useState([]);
  const [deliveryLoading, setDeliveryLoading] = useState(false);

  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") return onClickOrderTrackingModal();
  };

  // 렌더링 시 주문 상태, 택배사 정보 목데이터 가져오는 함수
  const getDeliveryList = async () => {
    const deliveryDummyList = dummyList?.delivery;

    let tempDeliveryArr = [];

    for (const key in deliveryDummyList) {
      tempDeliveryArr.push({
        value: key,
        label: deliveryDummyList[key],
      });
    }

    setDeliveryList(tempDeliveryArr);
  };

  // 배송상태 리스트 가져오기
  const getShippingTracking = async () => {
    setDeliveryLoading(true);
    const body = {
      modes: "Check",
      deliverycode: orderData?.delivery,
      deliverynum: orderData?.deliverynum,
    };

    const res = await postCommonDelivery(body);

    if (res?.status === 200) {
      if (res?.data?.Code === "0000") {
        setShipplingList(res?.data?.Data?.Rows);
      }
    }
    setDeliveryLoading(false);
  };

  // deliveryList 에서 현재 value 와 비교 후 label 을 찾는 함수
  const getLabelFromDeliveryList = (data) => {
    if (deliveryList !== undefined) {
      return deliveryList.find((el) => el.value === data)?.label;
    }
  };

  useEffect(() => {
    getDeliveryList();
    getShippingTracking();
  }, []);

  return (
    <>
      <ModalWrapper onShipping={shippingList?.length > 3 ? true : false}>
        <div className="modal-section">
          <div className="modal-header">
            배송 조회
            <i className="fi-rs-cross" onClick={onClickOrderTrackingModal} />
          </div>
          <div className="modal-content">
            {/* 배송조회 상단 */}
            <div className="status-top-wrapper">
              {orderData?.deliverystats === "1" && (
                <h4>현재 배송 대기 중 입니다.</h4>
              )}
              {orderData?.deliverystats === "2" && (
                <h4>현재 배송 중 입니다.</h4>
              )}
              {orderData?.deliverystats === "3" && (
                <h4>배송 완료 되었습니다.</h4>
              )}
              <div className="shipping-invoice">
                {[getLabelFromDeliveryList(orderData?.delivery)]}{" "}
                {orderData?.deliverynum && orderData?.deliverynum}
              </div>
            </div>
            {/* 배송조회 하단 */}
            <div className="status-btm-wrapper pt-5 mt-5">
              {/* box */}
              {deliveryLoading ? (
                <div className="loading m-auto d-flex align-items-center justify-content-center">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
                <div>
                  {orderData?.delivery && orderData?.deliverynum ? (
                    shippingList?.map((el, i) => (
                      <div className="box-wrapper" key={i}>
                        <div className="box-border">
                          <div className="width-flex-full">
                            <div className="width-70">
                              <p className="box-header">{el?.stats}</p>
                              <p className="box-sub-title">{el?.place}</p>
                            </div>
                            <div className="width-30">
                              <p className="date-time">{el?.time}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="box-wrapper">
                      <p className="text-center pb-20">
                        배송 시작 후 상태가 업데이트 됩니다.
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};

const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
});

export default connect(mapStateToProps, null)(OrderTrackingModal);
